/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  Button,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
  Switch,
  Divider,
  TextField,
  Tabs,
  Tab,
  CircularProgress
} from "@material-ui/core";

import { v4 as uuidv4 } from 'uuid';

import Actions from "../../../fluid/Actions/ActionFactory";

import viewer_config from "../../Results/components/Config/viewer_config";

import JSONAvatar from "../../Results/components/Avatars/JSONAvatar";
import EMAILAvatar from "../../Results/components/Avatars/EMAILAvatar";
import SMAvatar from "../../Results/components/Avatars/SMAvatar";
import PDFAvatar from "../../Results/components/Avatars/PDFAvatar";
import WORDAvatar from "../../Results/components/Avatars/WORDAvatar";
import PPTAvatar from "../../Results/components/Avatars/PPTAvatar";
import EXCELAvatar from "../../Results/components/Avatars/EXCELAvatar";
import CSVAvatar from "../../Results/components/Avatars/CSVAvatar";
import HTMLAvatar from "../../Results/components/Avatars/HTMLAvatar";
import TXTAvatar from "../../Results/components/Avatars/TXTAvatar";
import DBAvatar from "../../Results/components/Avatars/DBAvatar";
import IMAGEAvatar from "../../Results/components/Avatars/IMAGEAvatar";

import Viewer from "../../Results/components/FileViewers/Viewer";
import DisplayComponent from "./DisplayComponent/DisplayComponent";
import FlexForm from '../../FlexForm/FlexForm'
import FlexFormGenerator from '../../FlexFormGenerator/FlexFormGenerator'

const clone = require("rfdc")();

const field_sources = [
  {
    label: "World View",
    value: "wv_fields",
  },
  {
    label: "Source Fields",
    value: "raw_data",
  },
];

const field_styles = [
  {
    label: "ID",
    value: "id",
  },
  {
    label: "Body",
    value: "body",
  },
  {
    label: "Label",
    value: "label",
  },
];

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = (theme) => ({
  avatar: {
    margin: "5px",
    padding: "5px",
    cursor: "pointer",
  },
});

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(2),
    padding : theme.spacing(1),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

class ConfigureDisplay extends Component {
  state = {
    content_height: "",
    type: "",
    sub_type: "",
    default_viewer: "email",
    viewer: "email",
    config: null,
    write_form : [],
    raw_fields: true,
    edit: true,
    setup_err: false,
    cur_tab : 0
  };

  componentWillMount() {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        this.props.iu_name,
      method: "get",
      data: {},
    }).then((res) => {
      let type = res.data.result.type;
      let sub_type = res.data.result.sub_type;
      console.log("Type :" + type + " --- Sub Type: " + sub_type);

      let raw_fields = res.data.result.raw_fields;

      let viewer_object_index = viewer_config.findIndex((viewer) =>
        viewer.type.includes(type)
      );
      let viewer_object = viewer_config[viewer_object_index];
      let template = viewer_object.template;
      template.id = uuidv4();
      if (template.display !== null) {
        template.display.map(
          (el) => (el.id = uuidv4())
        );
      }

      this.setState(
        {
          ...this.state,
          type: type,
          sub_type: sub_type,
          default_viewer: viewer_object.viewer,
          viewer: viewer_object.viewer,
          config: template,
          raw_fields: raw_fields,
        },
        () => {
          console.log("Viewer Config State: ", this.state)
          Actions("http_request", {
            url:
              "/sainapse/information_channel/" +
              this.props.ic_name +
              "/world_view_fields",
            method: "get",
            data: {},
          }).then((res) => {
            let wv_fields = res.data.result.map((item) => {
              return item.name;
            });
      
            this.setState({ ...this.state, wv_fields: wv_fields }, () => {
              console.log("Got World View Fields: ", this.state)
              Actions("http_request", {
                url:
                  "/sainapse/information_channel/" +
                  this.props.ic_name +
                  "/information_unit/" +
                  this.props.iu_name +
                  "/field_in_scope",
                method: "get",
                data: {},
              }).then((res) => {
                let device_fields = res.data.result
                this.setState({ ...this.state, device_fields: device_fields }, () =>
                  console.log("Got Device Fields: ", this.state)
                );
              });
            }
            );
          });
        }
      );
    });
  }

  componentDidMount() {
    const headingHeight = this.heading.current.clientHeight;
    const footerHeight = this.footer.current.clientHeight;
    const contentHeight = this.props.maxHeight - headingHeight - footerHeight;

    this.setState({ ...this.state, content_height: contentHeight });
  }

  heading = React.createRef();
  footer = React.createRef();

  renderContent = () => {
    return (
      <Fragment>
        <div
          style={{
            width: "50%",
            height: this.state.content_height,
            overflow: "scroll",
          }}
        >
          {this.renderEditor()}
        </div>
        <div
          style={{
            backgroundColor: "#f5f8fb",
            width: "50%",
            height: this.state.content_height,
            overflow: "scroll",
          }}
        >
          {this.renderViewer()}
        </div>
      </Fragment>
    );
  };

  renderEditor = () => {
    return (
      <Fragment>
        {/* {this.renderRawFieldToggle()} */}
        {this.renderViewerList()}
        {this.state.config !== null ? this.renderDisplayConfigurator() : <CircularProgress variant = 'indeterminate' color ='primary'/>}
      </Fragment>
    );
  };
  // Ref BUG ID: #2661
  // renderRawFieldToggle = () => {
  //   return (
  //     <Fragment>
  //       <div
  //         style={{
  //           width: "100%",
  //           padding: "8px",
  //           display: "flex",
  //           flexDirection: "row",
  //           alignItems: "center",
  //           justifyContent: "center",
  //         }}
  //       >
  //         <ThemeProvider theme={blue_theme}>
  //           <FormControl>
  //             <div
  //               style={{
  //                 width: "100%",
  //                 display: "flex",
  //                 flexDirection: "row",
  //                 alignItems: "center",
  //               }}
  //             >
  //               <Typography
  //                 //style = {{color : '#FF3D3D'}}
  //                 variant="subtitle2"
  //               >
  //                 Exclude Source Fields
  //               </Typography>
  //               <Switch
  //                 disabled={!this.state.edit}
  //                 style={{
  //                   color:
  //                     this.state.raw_fields === true ? "#FF3D3D" : "#00C986",
  //                 }}
  //                 checked={this.state.raw_fields}
  //                 onChange={this.toggleRawField}
  //                 color="default"
  //               />
  //               <Typography
  //                 //style = {{color : '#00C986'}}
  //                 variant="subtitle2"
  //               >
  //                 Include Source Fields
  //               </Typography>
  //             </div>
  //             {/* <FormControlLabel
  //                               control={<Switch checked={this.state.raw_fields} onChange={this.toggleRawField} color = 'primary'/>}
  //                               label = {this.state.raw_fields === true ? "Including Raw Fields" : "Excluding Raw Fields"}
  //                               labelPlacement = 'start'
  //                           /> */}
  //             <FormHelperText>
  //               Including Source Fields will duplicate the data and double the
  //               size.
  //             </FormHelperText>
  //           </FormControl>
  //         </ThemeProvider>
  //       </div>
  //       <Divider />
  //     </Fragment>
  //   );
  // };

  toggleRawField = () => {
    this.setState({ ...this.state, raw_fields: !this.state.raw_fields }, () => {
      Actions("http_request", {
        url:
          "/sainapse/information_channel/" +
          this.props.ic_name +
          "/information_unit/" +
          this.props.iu_name +
          "/raw_fields",
        method: "post",
        data: this.state.raw_fields,
        headers: {
          "Content-Type": "application/json",
        },
        // data : {
        //     rawFields : this.state.raw_fields
        // }
      })
        .then((res) => {
          if (this.state.raw_fields === false) {
            let config = clone(this.state.config);
            if (config.id_key_source === "raw_data") {
              config.id_key_source = "";
              config.id_key_name = "";
            }
            config.display.map((el) => {
              if (el.key_source === "raw_data") {
                el.key_source = "";
                el.key_name = "";
              }
            });
            this.setState({ ...this.state, config: config }, () =>
              console.log("Display Config State: ", this.state)
            );
          }
        })
        .catch((err) => {
          this.setState({ ...this.state, raw_fields: !this.state.raw_fields });
        });
    });
  };

  renderViewerList = () => {
    const { classes } = this.props;
    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
            }}
          >
            <Typography variant="body2" color="textPrimary">
              {"Suggested Viewer: " + this.state.default_viewer.toUpperCase()}
            </Typography>
            <Typography variant="h6">
              {this.state.viewer.charAt(0).toUpperCase() +
                this.state.viewer.slice(1) +
                "  Viewer"}
            </Typography>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {this.renderAvatars()}
          </div>
        </div>
        <Divider />
      </Fragment>
    );
  };

  renderAvatars = () => {
    const { classes } = this.props;
    let avatars = viewer_config.map((viewer) => {
      return (
        <div
          className={classes.avatar}
          style={{ opacity: this.state.edit === true ? "1.0" : "0.5" }}
          onClick={() => this.setViewer(viewer.viewer)}
        >
          {React.createElement(viewer.avatar, {
            disabled: this.state.viewer === viewer.viewer ? false : true,
          })}
        </div>
      );
    });

    return avatars;
  };

  setViewer = (viewer) => {
    if (this.state.edit === true) {
      let viewer_object_index = viewer_config.findIndex(
        (el) => el.viewer === viewer
      );
      let viewer_object = viewer_config[viewer_object_index];
      let template = viewer_object.template;
      template.id = uuidv4();
      if (template.display !== null) {
        template.display.map(
          (el) => (el.id = uuidv4())
        );
      }
      this.setState({ ...this.state, viewer: viewer, config: template });
    }
  };

  handleTabChange = (event, newValue) => {
    this.setState({...this.state, cur_tab : newValue})
  }

  renderDisplayConfigurator = () => {
    return (
      <div>
        {this.renderTabs()}
        {this.renderTabContent()}
      </div>
    )
  };

  renderTabs = () => {
    if (this.state.config !== null) {
      return (
        <AntTabs
          value={this.state.cur_tab}
          indicatorColor="primary"
          textColor="primary"
          onChange={this.handleTabChange}
          aria-label="Display Config Tabs"
        >
          <AntTab label="View Configuration" />
          <AntTab label="Parameters" disabled = {this.state.config.params.length === 0 ? true : false}/>
          <AntTab label="Update Configuration" disabled = {this.state.config.write === null ? true : false}/>
        </AntTabs>
      )
    }
  }

  renderTabContent = () => {
    switch (this.state.cur_tab) {
      case 0 :
        return this.renderReadConfig()
      
      case 1 :
        return this.renderParams()

      case 2 :
        return this.renderWriteConfig()

      default :
        return null
    }
  }

  renderParams = () => {
    console.log("Display Config : ", this.state.config)
    if (this.state.config.params.length === 0) {
      return (
        <Typography style = {{margin : '10px'}} align="center" variant="body2" color="textSecondary">
            There are no parameters for this viewer
        </Typography>
      ) 
    } else {
      console.log("Params Form : ", this.state.config.params)
      return (
        <FlexForm 
          key = 'params'
          config = {this.state.config.params} 
          fields_in_scope = {[]} 
          update_parent = {(form) => this.updateParam(form)} 
          submit = {(form) =>  void 0} 
          grid_element_width = "96%"
        />
      )
    }
  }

  updateParam = (form) => {
    console.log("Params Form : ", form)
    let new_state = clone(this.state)
    new_state.config.params = form

    this.setState({...new_state}, () => console.log("Updated Params Form: ", this.state))
  }

  renderReadConfig = () => {
    return (
      <Fragment>
        <div style={{ width: "100%" }}>
          <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
            <Typography
              style={{ display: "block", margin: "5px" }}
              variant="overline"
              color="primary"
            >
              Identifier
            </Typography>
          </div>
          <div
            style={{
              width: "100%",
              backgroundColor: "#FFFFFF",
              padding: "5px",
            }}
          >
            {this.renderIDFieldSetup()}
          </div>
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
          <div style={{ width: "100%", backgroundColor: "#FFFFFF" }}>
            <Typography
              style={{ display: "block", margin: "5px" }}
              variant="overline"
              color="primary"
            >
              Fields
            </Typography>
          </div>
          <div
            style={{
              width: "100%",
              backgroundColor: "#FFFFFF",
              padding: "5px",
            }}
          >
            {this.renderDisplayFields()}
          </div>
        </div>
      </Fragment>
    );
  }

  addField = () => {
    let new_id = uuidv4()
    let new_field = {
      id: new_id,
      label: "",
      key_source: "",
      key_name: "",
      style: "body",
      field_attachments : false,
      embedded_attachments : false
    };

    let config = this.state.config;
    config.display.push(new_field);

    this.setState({ ...this.state, config: config });
  };

  deleteField = (id) => {
    let field_index = this.state.config.display.findIndex((el) => el.id === id);
    let config = clone(this.state.config);
    config.display.splice(field_index, 1);

    this.setState({ ...this.state, config: config });
  };

  getFields = (key_source) => {
    if (key_source === "wv_fields") {
      return this.state.wv_fields;
    } else if (key_source === "raw_data") {
      return this.state.device_fields.map(field => field.name);
    } else {
      return ["Location"];
    }
  };

  renderIDFieldSetup = () => {
    if (Object.keys(this.state.config).length !== 0) {
      if (this.state.config.display !== null) {
        return (
          <DisplayComponent
            key={this.state.config.id}
            id={this.state.config.id}
            label={this.state.config.name}
            label_field={"name"}
            field_source={this.state.config.id_key_source}
            field_sources={field_sources}
            field_source_field={"id_key_source"}
            field_name={this.state.config.id_key_name}
            field_names={this.getFields(this.state.config.id_key_source)}
            field_name_field={"id_key_name"}
            field_style={"id"}
            field_styles={[
              {
                label: "ID",
                value: "id",
              },
            ]}
            style_field={"style"}
            raw_fields={this.state.raw_fields}
            delete={false}
            edit={this.state.edit}
            attachment_settings = {false}
            updateConfig={(id, field, value) =>
              this.updateField(id, field, value)
            }
          />
        );
      } else {
        return (
          <Typography align="center" variant="body2" color="textSecondary">
            Identifier Configuration is not required for this viewer
          </Typography>
        );
      }
    }
  };

  renderDisplayFields = () => {
    if (Object.keys(this.state.config).length !== 0) {
      if (this.state.config.display !== null) {
        return (
          <div>
            {this.renderDisplayFieldList()}
            <Button
              disabled={!this.state.edit}
              style={{ margin: "5px" }}
              variant="outlined"
              color="primary"
              size="small"
              onClick={this.addField}
            >
              Add Field
            </Button>
          </div>
        );
      } else {
        return (
          <Typography align="center" variant="body2" color="textSecondary">
            Field Configuration is not required for this viewer
          </Typography>
        );
      }
    }
  };

  renderDisplayFieldList = () => {
    let items = this.state.config.display.map((item) => {
      return (
        <DisplayComponent
          key={item.id}
          id={item.id}
          label={item.label}
          label_field={"label"}
          field_source={item.key_source}
          field_sources={field_sources}
          field_source_field={"key_source"}
          field_name={item.key_name}
          field_names={this.getFields(item.key_source)}
          field_name_field={"key_name"}
          field_style={item.style}
          field_styles={field_styles}
          style_field={"style"}
          raw_fields={this.state.raw_fields}
          delete={true}
          delete_field={(id) => this.deleteField(id)}
          edit={this.state.edit}
          attachment_settings = {true}
          field_attachment_key = {"field_attachments"}
          field_attachments = {item.field_attachments}
          embedded_attachment_key = {"embedded_attachments"}
          embedded_attachments = {item.embedded_attachments}
          updateConfig={(id, field, value) =>
            this.updateConfig(id, field, value)
          }
        />
      );
    });

    return items;
  };

  updateField = (id, field, value) => {
    let config = clone(this.state.config);
    config[field] = value;

    this.setState({ ...this.state, config: config });
  };

  updateConfig = (id, field, value) => {
    let config = clone(this.state.config);

    let field_index = config.display.findIndex((el) => el.id === id);
    config.display[field_index][field] = value;

    this.setState({ ...this.state, config: config }, () =>
      console.log("Updated Config :", this.state.config)
    );
  };

  updateWriteConfig = (form) => {
    let config = clone(this.state.config)
    config.write = form
    this.setState({...this.state, config : config, write_form : form})
  }

  renderWriteConfig = () => {
    console.log("Display Config State :",  this.state)
    return (
      <FlexFormGenerator config = {this.state.config.write} heading = "Create Editable Record View" binding_keys = {this.state.device_fields} updateParent = {(form) => this.updateWriteConfig(form)}/>
    )
  }

  renderViewer = () => {
    if (this.state.config !== null) {
      if (this.state.cur_tab === 0) {
        if (this.state.config.display !== null) {
          return Viewer(
            {
              viewer: this.state.config.viewer,
              id: this.state.config.id,
              config: this.state.config,
              record: {},
              edit: true,
            },
            {}
          );
        } else {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <Typography style={{ display: "block" }} variant="button">
                  Preview Not Available
                </Typography>
                <Typography style={{ display: "block" }} variant="caption">
                  {this.state.config.name + " Viewer can handle the following file extensions: "}
                </Typography>
                <Typography style={{ display: "block" }} variant="subtitle2" color = 'primary'>{this.getExtensions(this.state.config.props.type).join(", ")}</Typography>
              </div>
            </div>
          );
        }
      } else if (this.state.cur_tab === 2) {
        return (
          <div style = {{width : '100%', maxHeight : '100%', margin : '10px', overflow : 'scroll'}}>
            <Paper style = {{width : '100%', padding : '10px'}}>
              <FlexForm config = {this.state.write_form} fields_in_scope = {[]} update_parent = {(form) => null}/>
            </Paper>
          </div>
        )
      }
    } else {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress variant = 'indeterminate' color = 'primary'/>
        </div>
      );
    }
  };

  getExtensions = (viewer_type) => {
    try {
      let viewer_index = viewer_config.findIndex(
        (viewer) => viewer.viewer === viewer_type
      );
      let extensions = viewer_config[viewer_index].sub_type;

      return extensions;
    } catch (err) {
      return [];
    }
  };

  renderSubmitAndEdit = () => {
    if (this.state.edit === true) {
      return (
        <Button
          style={{ marginRight: "10px" }}
          variant="contained"
          color="primary"
          size="small"
          onClick={this.submitConfig}
        >
          Submit Config
        </Button>
      );
    } else {
      return (
        <Fragment>
          <Button
            style={{ marginRight: "10px" }}
            variant="outlined"
            color="primary"
            size="small"
            onClick={this.editConfig}
          >
            Edit Config
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => this.completeSetUpAndClose()}
          >
            Finish
          </Button>
        </Fragment>
      );
    }
  };

  completeSetUpAndClose = () => {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        this.props.iu_name +
        "/setup_complete",
      method: "post",
      data: true,
      headers: {
        "Content-Type": "application/json",
      },
      // data : {
      //     rawFields : this.state.raw_fields
      // }
    })
      .then((res) => {
        this.props.handleNext();
      })
      .catch((err) => {
        this.setState({ ...this.state, setup_err: true });
      });
  };

  submitConfig = () => {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        this.props.iu_name +
        "/display_config",
      method: "post",
      data: {
        content : this.state.config
      },
    })
      .then((res) => {
        this.setState({ ...this.state, edit: !this.state.edit });
      })
      .catch((err) => {});
  };

  editConfig = () => {
    this.setState({ ...this.state, edit: !this.state.edit });
  };

  render() {
    return (
      <Paper elevation={0} square style={{ width: "100%", height: "100%" }}>
        <div
          ref={this.heading}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-end",
            backgroundColor: "#F0F0F0",
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            padding: "8px",
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Typography variant="h6">Configure display</Typography>
            {this.state.setup_err ? (
              <Typography style={{ color: "#dc014e" }} variant="caption">
                Error Completing Setup.
              </Typography>
            ) : null}
          </div>
          <ThemeProvider theme={blue_theme}>
            {this.renderSubmitAndEdit()}
          </ThemeProvider>
        </div>
        <div
          style={{
            width: "100%",
            height: this.state.content_height,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ThemeProvider theme={blue_theme}>
            {this.renderContent()}
          </ThemeProvider>
        </div>
        <div
          ref={this.footer}
          style={{
            height: "20px",
            backgroundColor: "#F0F0F0",
            borderTop: "1px solid rgba(0,0,0,0.12)",
          }}
        ></div>
      </Paper>
    );
  }
}

export default withStyles(styles)(ConfigureDisplay);
